import React from "react"
import { Sidebar } from "./sidebar";
import { Content } from "./content";
import { RoomDetail } from "../../shared/details/room";
import { Modals } from "../../modals";
import neonStore from "../../../stores/useNeon";
import clx from "classnames";
import { useGeneral } from "../../../stores/useGeneral";

export const Neon = () => {
  const detail = neonStore(state=>state.detail)
  const {darkmode} = useGeneral(state=>state);
  return (
        
    <div
    id="chat"
    className={clx(darkmode, 'scrollbar lg:grid lg:grid-cols-11 h-screen w-full overflow-hidden dark:text-white')}
  >
    <Sidebar />

    <Content />
    
    {detail && <RoomDetail /> }

  </div>
    )
}

 
 